import React from 'react'

const Contact = () => {
	return (
		<>
			<section className="section p-t-100 p-b-65" id="about-banner">
				<div className="container">
					<div className="page-heading">
						<h4 className="about_t">Contact Us</h4>
					</div>
				</div>
			</section>

			<div className="contact-f">
				<div className="portfolio"></div>
				<div className="contact-f">
					<div className="container">
						<div className="row">
							<div className="col-lg-4">
								{/* <div className="email-icon">
								<FaEnvelopeOpenText />
							</div> */}
								<p className="email">
									<span className="d-block">CAREER OPPORTUNITIES</span>
									If you are interested in joining our team, please feel free to
									call / write to us.
								</p>
								<p className="email">
									<span className="d-block">address:</span>
									dA Architecture Workshop, #44, 4th Cross, Sector A,
									Amruthnagar, Bengaluru – 560 092, India
								</p>
								<p className="email">
									<span className="d-block">PHONE NUMBER :</span> +91 80 2362
									7818
								</p>
								<p className="email">
									<span className="d-block">FAX :</span> +91 80 4213 3335
								</p>
								<p className="email">
									<span className="d-block">email :</span>{' '}
									davidashok@hotmail.com
								</p>
							</div>
							<div className="col-lg-8">
								<div className="form-p">
									<form
										class="contactform"
										action="https://formspree.io/f/mgegdazz"
										method="POST"
									>
										<div class="contactform">
											<div class="row">
												<div class="col-12 col-md-4">
													<input
														type="text"
														name="name"
														placeholder="YOUR NAME"
														className="input-box"
													/>
												</div>
												<div class="col-12 col-md-4">
													<input
														type="email"
														name="email"
														placeholder="YOUR EMAIL"
														className="input-box"
													/>
												</div>
												<div class="col-12 col-md-4">
													<input
														type="text"
														name="subject"
														placeholder="YOUR SUBJECT"
														className="input-box"
													/>
												</div>
												<div class="col-12">
													<textarea
														name="message"
														placeholder="YOUR MESSAGE"
														className="text-box"
													></textarea>
												</div>
												<div className="col-12">
													<button
														type="submit"
														className="button"
														name="submit"
													>
														<span class="button-text">Send Message</span>
														<span class="button-icon fa fa-send"></span>
													</button>
												</div>
												<div class="col-12 form-message">
													<span class="output_message text-center font-weight-600 text-uppercase"></span>
												</div>
												<div className=''>
													Location
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>

		//https://formspree.io/f/mgegdazz
	);
}

export default Contact